module.exports = __webpack_public_path__ + "static/media/img.de470b02.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/img.ico
// module id = 36
// module chunks = 0